type UnknownFunction = (...args: any[]) => unknown;

const getWarningExplanation = (packageName: string) => {
  return `Your app or its dependencies are using ${packageName}. ${packageName} depends on being provided with an implementation to work, but no implementation has been provided. In your app use registerImplementation from ${packageName} to register an implementation.`;
};

export const createStubImplementation = <
  T extends Record<string, UnknownFunction>,
>(
  packageName: string,
  defaultImplementation: T
) => {
  const _implementation: Record<string, UnknownFunction | undefined> = {};
  const registerImplementation = (implementation: T) => {
    Object.assign(_implementation, implementation);
  };
  const defaultImplementationEntries = Object.entries(defaultImplementation);
  const implementationWithWarningAndFallbackEntries =
    defaultImplementationEntries.map(
      ([methodName, defaultMethod]: [string, UnknownFunction]) => {
        return [
          methodName,
          (...args: unknown[]) => {
            const method = _implementation[methodName];
            if (!method) {
              const error = new Error(
                `${methodName} called without an implementation!\n\n${getWarningExplanation(
                  packageName
                )}`
              );
              setTimeout(() => {
                throw error;
              });
              return defaultMethod(...args);
            }
            return method(...args);
          },
        ];
      }
    );
  const implementation: T = Object.fromEntries(
    implementationWithWarningAndFallbackEntries
  );
  return { ...implementation, registerImplementation };
};
